import React, { useEffect, useState } from 'react'
import { Wrapper, Card, AvatarProfile, Btn  } from '../../_components'
import Table from '../../_components/Table'
import  Axios  from 'axios'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import Theme from '../../Theme'
import { capitalize } from '../../_utils'
import { getRegisteredFarmers } from '../../_slices/AppSlice'


const NameField = record => {
  let Name = record.value?.split(" ")

  return (
      <div className="flex flex-col items-start justify-center">
          <AvatarProfile bold label={`${capitalize( Name[ 0 ] )} ${capitalize( Name[ 1 ] )}`}/>
      </div>
  )
}

const ActionField = record => {
  const navigateTo = async ( id, tag ) => {
      await localStorage.setItem( "farmerId", id )
      await localStorage.setItem( "selectedFarmerName", record?.row.original.name )
      await localStorage.setItem( "selectedBlockId", record?.row.original.block )
      await localStorage.setItem( "selectedFFSCode", record?.row.original.ffs_code )
      await localStorage.setItem( "selectedPlotNo", record?.row.original.plotno )
      await localStorage.setItem( "selectedFarmerCode", record?.row.original.registration_no )
      await localStorage.setItem( "selectedPhoneNumber", record?.row.original.primary_contact )
      
      if( tag === "add" ) {
        await localStorage.setItem( "name", "ProductionForm" )
        await localStorage.removeItem( "tag" )
        return window.location.reload()
      }

      if( tag === "view" ) {
        await localStorage.setItem( "name", "view_production_all" )
        // await localStorage.setItem( "recordId", record?.row.original.id )
        // await localStorage.setItem( "tag", "view" )
        return window.location.reload()
      }

      if( tag === "edit" ) {
        await localStorage.setItem( "name", "ProductionForm" )
        // await localStorage.setItem( "recordId", record?.row.original.id )
        await localStorage.setItem( "tag", "edit" )
        return window.location.reload()
      }
  }
  
  return (
      <div className="flex items-center">
          {/* <Btn handlePress={() => navigateTo( record.value, "add" )} label="Add Production" color={`red`} /> */}
          {/* <Btn handlePress={() => navigateTo( record.value, "view" )} label="View production" color={`blue`} /> */}
          {/* <Btn handlePress={() => navigateTo( record.value, "edit")} label="Edit" color={`green`} /> */}
      </div>
  )
}

const Season1Field  = ( record ) => {
  const navigateTo = async ( id, tag, season ) => {
    await localStorage.setItem( "farmerId", id )
    await localStorage.setItem( "selectedFarmerName", record?.row.original.name )
    await localStorage.setItem( "selectedBlockId", record?.row.original.block )
    await localStorage.setItem( "selectedFFSCode", record?.row.original.ffs_code )
    await localStorage.setItem( "selectedPlotNo", record?.row.original.plotno )
    await localStorage.setItem( "selectedFarmerCode", record?.row.original.registration_no )
    await localStorage.setItem( "selectedPhoneNumber", record?.row.original.primary_contact )
    
    if( tag === "add" ) {
      await localStorage.setItem( "name", "ProductionForm" )
      await localStorage.setItem( "season", season )
      await localStorage.setItem( "operation", "add" )
      await localStorage.removeItem( "tag" )
      return window.location.reload()
    }

    if( tag === "view" ) {
      await localStorage.setItem( "name", "ViewProductionForm" )
      await localStorage.setItem( "season", season )
      await localStorage.setItem( "operation", "view" )
      await localStorage.removeItem( "tag" )
      return window.location.reload()
    }
  }

  return (
    record.value === "Yes" ?
    ( <div className="flex items-center cursor-pointer" onClick={() => navigateTo( record.value, "view", "season1" )}>
        <span className="bg-green-700 text-xs text-white px-2 py-1">
          {`View Season 1`}
        </span>
      </div> )  : (
      <div className="flex items-center cursor-pointer" onClick={() => navigateTo( record.value, "add", "season1" )}>
        <span className="bg-red-500 text-xs text-white px-2 py-1">
          {`Add Season 1`}
        </span>
      </div>
    )
  )
}

const Season2Field  = record => {

  const navigateTo = async ( id, tag, season ) => {
    await localStorage.setItem( "farmerId", id )
    await localStorage.setItem( "selectedFarmerName", record?.row.original.name )
    await localStorage.setItem( "selectedBlockId", record?.row.original.block )
    await localStorage.setItem( "selectedFFSCode", record?.row.original.ffs_code )
    await localStorage.setItem( "selectedPlotNo", record?.row.original.plotno )
    await localStorage.setItem( "selectedFarmerCode", record?.row.original.registration_no )
    await localStorage.setItem( "selectedPhoneNumber", record?.row.original.primary_contact )
    
    if( tag === "add" ) {
      await localStorage.setItem( "name", "ProductionForm" )
      await localStorage.setItem( "season", season )
      await localStorage.setItem( "operation", "add" )
      await localStorage.removeItem( "tag" )
      return window.location.reload()
    }

    if( tag === "view" ) {
      await localStorage.setItem( "name", "ViewProductionForm" )
      await localStorage.setItem( "season", season )
      await localStorage.setItem( "operation", "view" )
      await localStorage.removeItem( "tag" )
      return window.location.reload()
    }
  }

  return (
    record.value === "Yes" ?
    ( <div className="flex items-center cursor-pointer" onClick={() => navigateTo( record.value, "view", "season2" )}>
        <span className="bg-green-700 text-xs text-white px-2 py-1">
          {`View Season 2`}
        </span>
      </div> )  : (
      <div className="flex items-center cursor-pointer" onClick={() => navigateTo( record.value, "add", "season2" )}>
        <span className="bg-red-500 text-xs text-white px-2 py-1">
          {`Add Season 2`}
        </span>
      </div>
    )
  )
}

export default function() {
  const dispatch = useDispatch()
  const state = useSelector( state => {
    return {
      farmers: state.application.farmers,
      loading: state.application.loading
    }
  } )

  const farmerColumns = React.useMemo(
    () => [
        {
            Header: "#",
            accessor: "fNo",
            sortable: false
        },
        {
            Header: "Name",
            accessor: "name",
            sortable: false,
            filterable: false,
            Cell: NameField
        },
        {
          Header: "Registration No.",
          accessor: "registration_no"
        },
        {
            Header: "Block ID",
            accessor: "block"
        },
        {
            Header: "FFSG No.",
            accessor: "ffs_code"
        },
        // {
        //     Header: "Actions",
        //     accessor: "id",
        //     Cell: ActionField
        // },
        {
          Header: "Season 1",
          accessor: "season_1",
          Cell: Season1Field
        },
        {
          Header: "Season 2",
          accessor: "season_2",
          Cell: Season2Field
        }
        ]
  )
  const [ loading, setLoading ] = useState( true )
  const [ records, setRecords ] = useState( [] )

  useEffect( () => {
    if( state.loading ) {
        dispatch( getRegisteredFarmers() )
    }
  },[ state.loading ])

  let farmers =  state.farmers.filter( farmer => {
    return farmer
  } )

  return (
    <Wrapper>
      <div className="grid grid-cols-1 items-center">
        <Card 
          icon={Theme.PlusIcon} 
          title={`Add Farmer Production Data For ${localStorage.getItem( "scheme" )} Scheme Farmers`}>
          { state.loading ? (
             <div className="text-center font-bold text-green-700">
                {`Loading ${localStorage.getItem( "scheme" )} Scheme Farmers...`}
              </div>
            ) :
            <Table
              label="Farmer Production Data"
              columns={farmerColumns}
              data={state.farmers?.filter( item =>  { 
                return item.scheme?.toLowerCase() === localStorage.getItem( "scheme" ).replace( "_", " " )?.toLowerCase()
              } )
              .sort( ( a, b ) => {
                  return moment( b.created_at ).format( "YYYYMMDD" ) - moment( a.created_at ).format( "YYYYMMDD" )
              } )}
              hidePagination={false}
            /> }
        </Card>
      </div>
    </Wrapper>
  )
}
